import SubBroker from "./BrokerHome/BrokerHome"
import Info from "./Info/Info"
export default function SubBrokerMain(){
    return (
        <main>
        <SubBroker/>
        <Info/>
        </main>
    )
}